import styled from 'styled-components';
import { Typography } from '@mui/material';
import colors from '../../../../../../../styles/colors';

const ButtonContainer = styled.div`
  margin: 15px 0 5px 0;
  width: 250px;
`;

const InputContainer = styled.div`
  display: flex;
  flex-direction: column;
  width: 65%;
  margin: 15px 0;
  visibility: ${({ $isHidden }) => ($isHidden ? 'hidden' : 'visible')};
`;

const MasterOptionsWrapper = styled.div`
  display: flex;
  flex-direction: column;
  margin: 20px 0 30px 0;
`;

const MasterOptionsDescription = styled(Typography)`
  font-size: 14px;
`;

const HelperText = styled(Typography)`
  font-size: 13px;
  color: ${({ $isWarning }) => ($isWarning ? colors.base.warning : colors.shades.gamma7)};
  margin-bottom: 5px;
`;

export {
  ButtonContainer,
  MasterOptionsWrapper,
  MasterOptionsDescription,
  HelperText,
  InputContainer,
};
